/*Bank Transactions*/
import { type ICreateSepaMandateParams, type IGetSepaMandate, type ISEPAMandate, SEPAMandate } from '@condo/domain';
import { getClient } from './api-client';

export const getSepaMandates = async (params: IGetSepaMandate): Promise<SEPAMandate[]> =>
    getClient('basecamp')
        .get('/sepa-mandate', { params })
        .then(({ data }) => (data.sepaMandates as ISEPAMandate[]).map(sepa => new SEPAMandate(sepa)));

export const saveSepaMandate = async (params: ICreateSepaMandateParams): Promise<SEPAMandate> =>
    getClient('basecamp')
        .post('/sepa-mandate', params)
        .then(({ data }) => {
            return new SEPAMandate(data.sepaMandate as ISEPAMandate);
        });

export const deleteSepaMandate = async (sepaMandateId: number): Promise<void> => {
    await getClient('basecamp').delete(`/sepa-mandate/${sepaMandateId}`);
};
